import { useMemo } from "react";
import { useBarColumnColorByType } from "./useBarColumnColorByType";
import { G2PlotDatum } from "@ant-design/plots";

export const usePlotConfig = (data: any) => {
  const { getColor } = useBarColumnColorByType();

  const config: any = useMemo(
    () => ({
      data,
      isStack: true,
      xField: "xAxis",
      yField: "yAxis",
      height: 400,
      seriesField: "type",
      legend: {
        layout: "horizontal",
        position: "bottom",
        marker: {
          symbol: "circle",
        },
        maxRow: 2,
        flipPage: false,
        padding: [16, 0, 0, 0],
      },
      tooltip: {
        title: (_: any, datum: G2PlotDatum) => datum.tooltipHeader,
      },
      color: ({ type }: { type: string }) => getColor(type),
    }),
    [data, getColor],
  );

  return { config };
};
